import { Loading } from '@components/common/Loading/Loading';
import { Secured } from '@components/Secured/Secured';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { FREE, MORTALITY, REPORT, TASK } from '@/constants/routes';
import { MortalityReportComponent } from '@/pages/Report/components/MortalityReport/MortalityReport';
import { ReportComponent } from '@/pages/Report/components/ReportComponent/ReportComponent';
import { OrganizationLevelType } from '@/shared/organizations/enums';
import { ReportType } from '@/shared/report/enum';
import { report } from '@/shared/security/permissions/report';

export const freeReportLevel = [
  OrganizationLevelType.ROOT,
  OrganizationLevelType.DISTRICT,
  OrganizationLevelType.REGION,
];

const LazyReport = lazy(() =>
  import('./ReportPage').then((module) => ({
    default: module.ReportPage,
  })),
);

const baseRoute: RouteObject = {
  path: REPORT,
  element: <Loading children={<LazyReport />} />,
  children: [],
};

const reportRoutes = [
  {
    path: REPORT + TASK,
    element: (
      <Secured security={{ permissions: report.taskReport.view }}>
        <ReportComponent type={ReportType.TASK} key={ReportType.TASK} />
      </Secured>
    ),
  },
  {
    path: REPORT + FREE,
    element: (
      <Secured
        security={{
          permissions: report.summaryReport.view,
          level: freeReportLevel,
        }}>
        <ReportComponent type={ReportType.FREE} key={ReportType.FREE} />
      </Secured>
    ),
  },
  {
    path: REPORT + MORTALITY,
    element: (
      <Secured security={{ permissions: report.mortalityReport.view }}>
        <MortalityReportComponent />
      </Secured>
    ),
  },
];
baseRoute.children = [...reportRoutes];
const routes = baseRoute.children.length > 0 ? [baseRoute] : [];

export const ReportRoutes = routes;
